import { Flex } from 'antd';
import styles from './annotations.module.scss';
import { Comment } from '../comment/comment';
import { TextArea } from '../form/textarea/textarea';
import { Button } from '../button/button';
import AnnotationPlus from '@/assets/icons/annotation-plus.svg?react';
import { Annotation } from '@/services/conversations-service/conversations-service.types';

interface AnnotationsProps {
  annotations: Annotation[];
  onTextChange: (value: string) => void;
  value: string;
  addAnnotation: (value: string) => void;
  isLoading?: boolean;
}

export function Annotations({
  annotations,
  onTextChange,
  value,
  addAnnotation,
  isLoading = false,
}: AnnotationsProps) {
  return (
    <Flex vertical align="center" className={styles.annotationsContainer}>
      {annotations.map(({ id, user_full_name, created_at, message }) => (
        <Comment key={id} date={created_at} name={user_full_name} text={message} />
      ))}
      <p className={styles.annotationText}>Annotation to this segment</p>
      <TextArea
        value={value}
        onChange={(event) => onTextChange(event.target.value)}
        placeholder="Add your comment"
        containerClass={styles.annotationsTextAreaContainer}
        className={styles.annotationsTextArea}
      />
      <Button
        loading={isLoading}
        disabled={!value}
        onClick={() => addAnnotation(value)}
        icon={<AnnotationPlus strokeWidth={2} />}
        rightIcon
        className={styles.annotationsButton}
      >
        Add an annotation
      </Button>
    </Flex>
  );
}
